import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const partnerLogos = [
    { name: "Partner 1", logo: "/images/partners/partner1.png" },
    { name: "Partner 2", logo: "/images/partners/partner2.png" },
    { name: "Partner 3", logo: "/images/partners/partner3.png" },
    { name: "Partner 4", logo: "/images/partners/partner4.png" },
    { name: "Partner 5", logo: "/images/partners/partner5.png" },
    { name: "Partner 6", logo: "/images/partners/partner6.png" },
  ];

export const Partners = () => {
    const { t } = useTranslation();
  return (
    <section id="partners" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true, amount: 0.5 }}
            className="text-center md:text-left max-w-3xl mb-14"
        >
          <h2 className="text-3xl md:text-4xl font-bold">{t('partners.title')}</h2>
          <p className="text-lg text-gray-600 mt-4">
            {t('partners.subtitle')}
          </p>
        </motion.div>
        
        <div className="relative overflow-hidden">
          <motion.div
            className="flex gap-16"
            animate={{
              x: ['0%', '-100%'],
              transition: {
                ease: 'linear',
                duration: 20,
                repeat: Infinity,
              }
            }}
          >
            {[...partnerLogos, ...partnerLogos].map((partner, index) => (
              <div key={index} className="flex-shrink-0">
                <img
                  src={partner.logo}
                  alt={partner.name}
                  loading="lazy"
                  decoding="async"
                  className="partner-logo grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-300"
                />
              </div>
            ))}
          </motion.div>
          <div className="absolute inset-0 bg-gradient-to-r from-white via-transparent to-white pointer-events-none" />
        </div>
      </div>
    </section>
  );
};
